import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { localDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Container,
    FilterBarDropdown,
    FilterBarPlaceholder,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { CheckIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Deferred, router, usePage } from '@inertiajs/react';
import axios from 'axios';

const InvalidBsnView = () => {
    const { auth, employees, customers } = usePage().props;
    const { filters, updateFilters } = useFilters(['employees']);

    const { confirm } = useConfirmationStore();

    const confirmDelete = employee =>
        confirm({
            title: 'Werknemer verwijderen?',
            description: `Weet je zeker dat je ${employee.name} wilt verwijderen? Alle gekoppelde gegevens worden ook verwijderd. Deze actie kan niet ongedaan worden gemaakt.`,
            confirmLabel: 'Verwijderen',
            onConfirm: async close => {
                try {
                    // TODO: Change to customer scoped web route when ready
                    await axios.delete(`/api/employees/${employee.id}`);
                } finally {
                    router.reload({
                        only: ['employees'],
                        onFinish: close,
                    });
                }
            },
        });

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Ongeldige BSNs (${employees?.meta?.total || 0})`}
                />
                <SegmentContent>
                    <SearchBarFilter only={['employees']}>
                        <Deferred
                            data='customers'
                            fallback={<FilterBarPlaceholder />}
                        >
                            <FilterBarDropdown
                                clearable
                                multiple
                                label={`Klanten (${filters?.customer_ids?.length}/${customers?.length})`}
                                value={filters?.customer_ids || []}
                                options={customers || []}
                                onChange={value =>
                                    updateFilters('customer_ids', value)
                                }
                            />
                        </Deferred>
                    </SearchBarFilter>

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>Entiteit</TableHeaderCell>
                                <TableHeaderCell>Naam</TableHeaderCell>
                                <TableHeaderCell>BSN</TableHeaderCell>
                                <TableHeaderCell>Geboortedatum</TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Datahub
                                </TableHeaderCell>
                                <TableHeaderCell />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {employees?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={6} />
                            )}

                            {employees?.data?.map(employee => (
                                <TableRow key={employee.id}>
                                    <TableCell>
                                        {employee?.entity?.name}
                                    </TableCell>
                                    <TableCell>
                                        {auth?.permissions?.includes(
                                            'view employees'
                                        ) ? (
                                            // TODO: Change to Link
                                            <a
                                                href={`/employees/${employee.id}`}
                                            >
                                                {employee.name}
                                            </a>
                                        ) : (
                                            employee.name
                                        )}
                                    </TableCell>
                                    <TableCell>{employee.bsn}</TableCell>
                                    <TableCell>
                                        {localDate(employee.birth_date)}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        {employee?.datahub_id ? (
                                            <CheckIcon className='inline-flex size-4 text-green-600' />
                                        ) : (
                                            <XMarkIcon className='inline-flex size-4 text-red-600' />
                                        )}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {auth?.permissions?.includes(
                                            'delete employees'
                                        ) && (
                                            <Button
                                                variant='danger'
                                                onClick={() =>
                                                    confirmDelete(employee)
                                                }
                                            >
                                                <TrashIcon className='size-4' />
                                            </Button>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={employees?.meta}
                        only={['employees']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default InvalidBsnView;
